import React, { useEffect, useState  } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getGSTR2BSummaryQuarter,
  getGSTR2BDetailsQuarter,

} from '../api/misApis';

import  "../Assets/Css/alert.css"

function GstRecoQuarter() {
  const [summary, setSummary] = useState([]);
  const [details, setDetails] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, ] = useState('');
 

  const navigate = useNavigate();

  const rowsPerPage = 10;

  useEffect(() => {
    getGSTR2BSummaryQuarter()
      .then((res) => setSummary(res.data))
      .catch((err) => console.error(err));

  }, []);

  const handleSupplierClick = (supplier) => {
    setSelectedSupplier(supplier);
    getGSTR2BDetailsQuarter(supplier)
      .then((res) => setDetails(res.data))
      .catch((err) => console.error(err));
  };



  const filterRows = (rows) => {
    if (!searchTerm.trim()) return rows;
    return rows.filter((row) =>
      Object.values(row).some((val) =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  };

  const filteredSummary = filterRows(summary);
  const filteredDetails = filterRows(details);

  // const filterRCMandLogic = filterRows(rcmAndLogic);

  const gstrColumns = [
    "GSTIN_GSTR2B", "Supplier_GSTR2B", "Quarter_GSTR2B", "InvoiceValue_GSTR2B", "TaxableValue_GSTR2B",
    "IntegratedTax_GSTR2B", "CentralTax_GSTR2B", "StateUTTax_GSTR2B",
    "GSTIN_Logic", "Supplier_Logic", "Quarter_Logic", "InvoiceValue_Logic", "TaxableValue_Logic",
    "IntegratedTax_Logic", "CentralTax_Logic", "StateUTTax_Logic",
    "InvoiceValueDiff", "TaxableValueDiff", "IntegratedTaxDiff", "CentralTaxDiff", "StateUTTaxDiff", "DiffFlag"
  ];

  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentRows = filteredSummary.slice(startIndex, startIndex + rowsPerPage);
  const totalPages = Math.ceil(filteredSummary.length / rowsPerPage);




  return (
    <div className="p-4">
    <div id="alertPlaceholder"></div>
   <div className="mb-4 flex justify-between items-center flex-wrap gap-4">
  <button
    onClick={() => navigate(-1)}
    className="px-3 py-1 bg-gray-700 text-white rounded hover:bg-gray-800 text-sm"
  >
    ⬅️ Back to Home
  </button>

 
</div>


   

 
  


      {/* GSTR-2B Summary */}
      <h2 className="text-xl font-semibold mb-4">GSTR-2B Summary</h2>
      <div className="overflow-auto border rounded shadow">
        <table className="min-w-[1200px] text-sm border-collapse w-full">
          <thead className="bg-gray-100 font-bold">
            <tr>
              {gstrColumns.map((col) => (
                <th key={col} className="px-2 py-2 border">{col.replace(/_/g, ' ')}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentRows.map((item, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSupplierClick(item.Supplier_Logic || item.Supplier_GSTR2B)}
              >
                {gstrColumns.map((col) => (
                  <td
                    key={col}
                    className={`px-2 py-1 border text-xs ${
                      col === 'DiffFlag'
                        ? item[col] === 'Red'
                          ? 'text-red-600 font-semibold'
                          : item[col] === 'Green'
                          ? 'text-green-600 font-semibold'
                          : ''
                        : 'text-gray-800'
                    }`}
                  >
                    {item[col]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-3 flex justify-between items-center">
        <span className="text-sm">Page {currentPage} of {totalPages}</span>
        <div className="space-x-2">
          <button
            onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
            disabled={currentPage === 1}
            className="px-2 py-1 bg-gray-200 rounded disabled:opacity-50"
          >Prev</button>
          <button
            onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
            disabled={currentPage === totalPages}
            className="px-2 py-1 bg-gray-200 rounded disabled:opacity-50"
          >Next</button>
        </div>
      </div>

      {selectedSupplier && (
        <div className="mt-6">
          <h3 className="font-semibold mb-2">Invoice Details for: {selectedSupplier}</h3>
          <div className="overflow-auto border rounded shadow">
            <table className="min-w-[1500px] text-sm border-collapse w-full">
              <thead className="bg-gray-100 font-bold">
                <tr>
                  {["InvoiceNo_GSTR2B", "Supplier_GSTR2B", "InvoiceDate_GSTR2B", "Quarter_GSTR2B",
                    "InvoiceValue_GSTR2B", "TaxableValue_GSTR2B", "IntegratedTax_GSTR2B", "CentralTax_GSTR2B", "StateUTTax_GSTR2B",
                    "InvoiceNo_Logic", "Supplier_Logic", "InvoiceDate_Logic", "Quarter_Logic",
                    "InvoiceValue_Logic", "TaxableValue_Logic", "IntegratedTax_Logic", "CentralTax_Logic", "StateUTTax_Logic",
                    "InvoiceValueDiff", "TaxableValueDiff", "IntegratedTaxDiff", "CentralTaxDiff", "StateUTTaxDiff", "DiffFlag"
                  ].map((col) => (
                    <th key={col} className="px-2 py-2 border whitespace-nowrap">{col.replace(/_/g, ' ')}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredDetails.map((row, idx) => (
                  <tr key={idx} className="hover:bg-gray-100">
                    {["InvoiceNo_GSTR2B", "Supplier_GSTR2B", "InvoiceDate_GSTR2B", "Quarter_GSTR2B",
                      "InvoiceValue_GSTR2B", "TaxableValue_GSTR2B", "IntegratedTax_GSTR2B", "CentralTax_GSTR2B", "StateUTTax_GSTR2B",
                      "InvoiceNo_Logic", "Supplier_Logic", "InvoiceDate_Logic", "Quarter_Logic",
                      "InvoiceValue_Logic", "TaxableValue_Logic", "IntegratedTax_Logic", "CentralTax_Logic", "StateUTTax_Logic",
                      "InvoiceValueDiff", "TaxableValueDiff", "IntegratedTaxDiff", "CentralTaxDiff", "StateUTTaxDiff", "DiffFlag"
                    ].map((col) => (
                      <td key={col} className={`px-2 py-1 border text-xs ${
                        col === 'DiffFlag'
                          ? row[col] === 'Red'
                            ? 'text-red-600 font-semibold'
                            : row[col] === 'Green'
                            ? 'text-green-600 font-semibold'
                            : ''
                          : 'text-gray-800'
                      }`}>
                        {row[col]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}


    </div>
  );
}

export default GstRecoQuarter;
